/**
 * @generated SignedSource<<0891df087f6d66f84e01512fdcb0d6cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type eventGuestDeleteMutation$variables = {
  id: string;
};
export type eventGuestDeleteMutation$data = {
  readonly deleteEventGuest: {
    readonly id: string;
  };
};
export type eventGuestDeleteMutation = {
  variables: eventGuestDeleteMutation$variables;
  response: eventGuestDeleteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "EventGuestDeletePayload",
    "kind": "LinkedField",
    "name": "deleteEventGuest",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "eventGuestDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "eventGuestDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a07d25172d1628221a578a840a0c104d",
    "id": null,
    "metadata": {},
    "name": "eventGuestDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation eventGuestDeleteMutation(\n  $id: ID!\n) {\n  deleteEventGuest(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4e116d784f885adfcd5a4dd9f9414ee";

export default node;
